import { render, staticRenderFns } from "./ModalUploadAvatar.vue?vue&type=template&id=7b9f99ea&scoped=true"
import script from "./ModalUploadAvatar.vue?vue&type=script&lang=js"
export * from "./ModalUploadAvatar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b9f99ea",
  null
  
)

export default component.exports